
import { defineComponent } from "vue";
import GradientImage from "./gradientImage.vue";
import GradientEditor from "./gradientEditor.vue";
class Gradient {
	id = "";
	rgbPoints = [];
	value = "";
	text = "";
	type = "";
	constructor(text: string, value: string, rgbPoints: any, type = "continuous") {
		this.text = text;
		this.value = value;
		this.type = type;
		this.rgbPoints = rgbPoints;
		const guidGenerator = () => {
			const S4 = () => {
				return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
			};
			return S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4();
		};
		this.id = guidGenerator();
	}
}
export default defineComponent({
	name: "imdex-edit-gradients",
	components: {
		GradientImage,
		GradientEditor
	},
	data() {
		return {
			searchTerm: "",
			activeGradient: null as any,
			continuousLocal: [] as any,
			continuousFixedLocal: [] as any,
			refreshKey: 0
		};
	},
	props: {
		continuous: {
			type: Array as any,
			default: () => [] as any
		},
		continuousFixed: {
			type: Array as any,
			default: () => [] as any
		}
	},

	methods: {
		newFixedGradient() {
			if (
				this.activeGradient &&
				this.activeGradient.text == this.$t("ssa.displayPane.colorGeneral.newFixedGradient")
			) {
				return;
			}
			this.continuousFixedLocal.push(
				new Gradient(
					this.$t("ssa.displayPane.colorGeneral.newFixedGradient"),
					this.$t("ssa.displayPane.colorGeneral.newFixedGradient"),
					[
						0, 1, 1, 1, 0.33, 1, 1, 1, 0.33, 1, 0, 0, 0.66, 1, 0, 0, 0.66, 0, 0, 1, 1,
						0, 0, 1
					],
					"fixed"
				)
			);
			this.activeGradient = this.continuousFixedLocal[0];
		},
		newGradient() {
			if (
				this.activeGradient &&
				this.activeGradient.text == this.$t("ssa.displayPane.colorGeneral.newGradient")
			) {
				return;
			}
			this.continuousLocal.push(
				new Gradient(
					this.$t("ssa.displayPane.colorGeneral.newGradient"),
					this.$t("ssa.displayPane.colorGeneral.newGradient"),
					[-1, 0, 0, 0, 1, 1, 1, 1]
				)
			);
			this.activeGradient = this.continuousLocal[0];
		},
		hexToRgb(hex: string) {
			const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
			return {
				r: parseInt(result![1], 16),
				g: parseInt(result![2], 16),
				b: parseInt(result![3], 16)
			};
		},
		rgbToHex(r: number, g: number, b: number) {
			const componentToHex = (c: any) => {
				const hex = c.toString(16);
				return hex.length == 1 ? "0" + hex : hex;
			};
			return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
		}
	},
	computed: {
		isANewGradient() {
			return (
				(this.activeGradient &&
					this.activeGradient.text ==
						this.$t("ssa.displayPane.colorGeneral.newGradient")) ||
				(this.activeGradient &&
					this.activeGradient.text ==
						this.$t("ssa.displayPane.colorGeneral.newFixedGradient"))
			);
		},
		continuousFiltered(): any {
			this.refreshKey;
			if (this.searchTerm == "") {
				return [...this.continuous, ...this.continuousLocal];
			} else {
				return [
					...this.continuous.filter(
						(item: any) => item.text.toLowerCase().indexOf(this.searchTerm) > -1
					),
					...this.continuousLocal
				];
			}
		},
		continuousFixedFiltered(): any {
			this.refreshKey;
			if (this.searchTerm == "") {
				return [...this.continuousFixed, ...this.continuousFixedLocal];
			} else {
				return [
					...this.continuousFixed.filter(
						(item: any) => item.text.toLowerCase().indexOf(this.searchTerm) > -1
					),
					...this.continuousFixedLocal
				];
			}
		}
	}
});
